import { postWithJson } from 'library/utils/serviceUtil'

/**
 *  获取bugs列表
 */
export const getBugsList = (params = {}) => {
	return postWithJson('/bug/list.py', params)
}

/**
 * 搜索姓名
 */
export const getNameList = (params = {}) => {
	return postWithJson('/seachName.py', params)
}

/**
 * 发送邮件
 */
export const sendMail = (params = {}) => {
	return postWithJson('/sendMail.py', params)
}
